<template>
  <vs-tabs
    v-model="activeTab"
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? $t(`COMPANIES.listCompanies`) : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <company-list @sendKey="getKey($event)" />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? titleTab : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <new-company
          :keyCompany="keyCompany"
          @destroy="keyCompany = null"
          @changeTab="activeTab = $event"
        ></new-company>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import CompanyList from "./CompanyList";
import NewCompany from "./company-edit/CompanyEditTabAccount.vue";

export default {
  components: {
    CompanyList,
    NewCompany
  },
  data() {
    return {
      activeTab: 0,
      keyCompany: null
    };
  },
  methods: {
    getKey(keyCompany) {
      this.keyCompany = keyCompany;
      this.activeTab = 1;
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    titleTab() {
      return this.keyCompany === null ? this.$t(`COMPANIES.newCompany`) : this.$t(`COMPANIES.updateCompany`);
    }
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
